module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": _vm.name
    },
    on: {
      "change": _vm.change,
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      domProps: {
        "value": group.id
      }
    }, [_vm._v(_vm._s(group.name))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e66303b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupsSelect.vue
// module id = 166
// module chunks = 1